import { jsx as a } from "react/jsx-runtime";

import s from "react-loading-skeleton";

import e from "../../../../utils/classNames/index.js";

const l = ({className: l, containerClassName: o, ...r}) => a(s, {
    ...r,
    baseColor: "#E4E6EB",
    containerClassName: o,
    className: e("h-full w-full", l)
});

export { l as default };
//# sourceMappingURL=index.js.map
